import { GrassCuts, GrassManagement } from "./generated/enums";
import { param } from "./generated/labels";

// This relies upon there being no overlap between values in "GrassManagementEngland" and "GrassManagementScotland".
const GRASS_MANAGEMENT: Map<number, string> = new Map(
    param
        .GrassManagementEngland()
        .concat(param.GrassManagementScotland())
        .map((x) => [Number(x.value), x.text])
);

const GRASS_CUTS: Map<number, string> = new Map(param.GrassCuts().map((x) => [Number(x.value), x.text]));

const UNKNOWN_LABEL = "???";

/**
 * Gets a formatted label for a `[GrassManagement, GrassCuts]` tuple
 * @param grassManagement The `GrassManagement` value.
 * @param grassCuts The `GrassCuts` value (optional)
 * @returns A combined label for the `[GrassManagement, GrassCuts]` tuple. (e.g. "Intensive grazing / 4 cuts or more")
 */
export function getCombinedGrassLabel(grassManagement: GrassManagement, grassCuts?: GrassCuts) {
    const managementLabel = GRASS_MANAGEMENT.get(grassManagement) ?? UNKNOWN_LABEL;
    return grassCuts === null || grassCuts === undefined
        ? managementLabel
        : `${managementLabel} / ${GRASS_CUTS.get(grassCuts) ?? UNKNOWN_LABEL} cuts`;
}
